export const CurrencySymbols: Record<string, string> = {
  UAH: '₴',
  USD: '$',
  EUR: '€',
  PLN: 'zł',
  CZK: 'Kč'
};
